import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { GxForm } from '@garpix/garpix-web-components-react'
import Button from '@/components/Button'
import ErrorText from '@/components/ErrorText'
import ErrorAllText from '@/components/ErrorText/AllErros'
import Input from '@/components/Input'
import Textarea from '@/components/Textarea'
import UploadPhoto from './UploadPhoto'
import { cleanValues } from '@/utils'
import { addContestWork } from '@/utils/schemesFormik'
import { IPropsAddWorkForm } from '../interface'
import { useModal } from '@/hooks'
import { REQUEST_STATUS } from '@/const'
import { api } from '@/api'
import style from '../styles/add.module.scss'

const AddWorkForm = ({
  contestId,
  url = '/'
}: IPropsAddWorkForm): React.ReactElement => {
  const { openModal } = useModal()
  const [btnDisabled, setBtnDisabled] = useState(true)

  const handleOpenModal = (): void => {
    openModal('workUploaded', { url })
  }

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: addContestWork,
    initialValues: {
      name: '',
      description: '',
      file: null,
      apiError: ''
    },

    onSubmit (values, { setSubmitting, resetForm, setErrors }): void {
      const vals = cleanValues({ values, keys: ['apiError'] })
      api
        .setContestWork({ id: contestId }, vals)
        .then(res => {
          if (res.status === REQUEST_STATUS.ok) {
            resetForm()
            handleOpenModal()
          }
        })
        .catch((err: any) => {
          setErrors({ apiError: err?.response?.data?.errorText })
          setSubmitting(false)
        })
    }
  })

  const {
    errors,
    isSubmitting,
    touched,
    values,
    handleBlur,
    handleChange,
    setFieldValue,
    submitForm
  } = formik

  useEffect(() => {
    const disabled = isSubmitting || Object.keys(errors).length > 0
    setBtnDisabled(Boolean(disabled))
  }, [isSubmitting, errors, values])

  const uploadPhoto = async (e: any): Promise<void> => {
    const { files = [], name = '' } = e.target
    await setFieldValue(name, files[0])
  }

  return (
    <GxForm novalidate onGx-submit={submitForm}>
      <div className={style.add_flex}>
        <div>
          <UploadPhoto
            className={style.add__upload}
            name='file'
            photo={values.file}
            required
            onChange={uploadPhoto}
            onBlur={handleBlur}
          />
          {touched.file === true && errors.file !== ''
            ? (
              <ErrorText text={errors.file} />
              )
            : null}
        </div>

        <div className={style.add__form}>
          <Input
            className={style.add__input}
            error={
              touched.name === true && errors.name !== '' ? errors.name : ''
            }
            label='Название работы:'
            name='name'
            required
            theme='secondary'
            type='text'
            value={values.name}
            onGx-blur={handleBlur}
            onGx-input={handleChange}
          />
          <Textarea
            className={style.add__textarea}
            error={
              touched.description === true && errors.description !== ''
                ? errors.description
                : ''
            }
            label='Расскажи о своей работе:'
            name='description'
            rows={6}
            theme='secondary'
            value={values.description}
            onGx-blur={handleBlur}
            onGx-input={handleChange}
          />
          {errors.apiError !== ''
            ? (
              <div>
                <ErrorAllText text={errors.apiError} />
              </div>
              )
            : null}
          <Button
            className={style.add__button}
            highlight
            size='extralarge'
            type='submit'
            wide
            disabled={btnDisabled}
          >
            Загрузить
          </Button>
        </div>
      </div>
    </GxForm>
  )
}

export default AddWorkForm
